module.exports = __webpack_public_path__ + "static/media/hall-kv.fd6f89c2.png";